module.exports = __webpack_public_path__ + "resources/img/img_moai_backup_func_m.a190c0dcc048ad2864435c013e41441d.png";